// extracted by mini-css-extract-plugin
export default {"layout":"Header_layout__a8QzE","hidden":"Header_hidden__TCPaO"};